var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Card } from '@philips-internal/oswald-ui-components/lib/components';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import GlycemicDetailsCardAPI from './glycemic-details-card-api';
import moment from 'moment';
import { ReactComponent as Checked } from '../../assets/images/global/checked.svg';
import { ReactComponent as CirclePause } from '../../assets/images/global/circle-pause.svg';
import { ReactComponent as CirclePlay } from '../../assets/images/global/circle-play.svg';
import { ReactComponent as ClockYellow } from '../../assets/images/global/clock-yellow.svg';
import { ReactComponent as PatientCheck } from '../../assets/images/global/patient-check.svg';
import { ReactComponent as PatientClock } from '../../assets/images/global/patient-clock.svg';
import { ReactComponent as PatientFirst } from '../../assets/images/global/patient-first.svg';
import { ReactComponent as PillCrusherClock } from '../../assets/images/global/pill-crusher-clock.svg';
import { ReactComponent as PillCrusherEye } from '../../assets/images/global/pill-crusher-eye.svg';
import { ReactComponent as AdditionalAttackDoseIcon } from '../../assets/images/global/attack-dose.svg';
import './glycemic-details-card.css';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let GlycemicDetailsCard = class GlycemicDetailsCard extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            hourStatus: '',
        };
        this.handleClick = () => {
            const { onClick, ...rest } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        rest
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderItemTitle(icon, titleOne, titleTwo) {
        return (React.createElement("div", { className: 'c-glycemic-details-card__description-name' },
            React.createElement("div", { className: 'c-glycemic-details-card__pill-crusher-eye' }, icon),
            React.createElement("span", { className: 'c-glycemic-details-card__description-name-text' }, titleOne || titleTwo)));
    }
    renderDefaultItem(textTitle, itemValue, className) {
        return (React.createElement("div", { className: `c-glycemic-details-card__default-infos ${className}` },
            React.createElement("span", { className: 'c-glycemic-details-card__default-title' }, textTitle),
            React.createElement("span", { className: 'c-glycemic-details-card__default-text' }, itemValue)));
    }
    renderIcon(hourStatus) {
        switch (hourStatus) {
            case 'ADMINISTERED':
                return React.createElement(Checked, null);
            case 'CHECKED_FIRST':
                return React.createElement(PatientFirst, null);
            case 'INTERRUPTED':
                return React.createElement(CirclePause, null);
            case 'PENDING':
                return React.createElement(ClockYellow, null);
            case 'PENDING_REFUSAL':
                return React.createElement(PatientClock, null);
            case 'PREPARATION':
                return React.createElement(PillCrusherClock, null);
            case 'REFUSED_ADMINISTERED':
                return React.createElement(PatientCheck, null);
            case 'STARTED':
                return React.createElement(CirclePlay, null);
            case 'E':
            case 'ADDITIONAL_ATTACK_DOSE':
                return React.createElement(AdditionalAttackDoseIcon, null);
            case 'A':
                return React.createElement(Checked, null);
            case 'C':
                return React.createElement(PatientCheck, null);
            case 'J':
                return React.createElement(PatientClock, null);
            case 'L':
                return React.createElement(PillCrusherEye, null);
            case 'N':
                return React.createElement(ClockYellow, null);
            case 'P':
                return React.createElement(PillCrusherClock, null);
            case 'Q':
                return React.createElement(PatientFirst, null);
            default:
                return null;
        }
    }
    renderDescriptionName() {
        const { itemDescription, statusSchedule } = this.props;
        const { hourStatus } = this.state;
        const statusItemValue = hourStatus || statusSchedule;
        const iconStatus = this.renderIcon(statusItemValue);
        return (this.renderItemTitle(iconStatus, '', itemDescription));
    }
    renderContent() {
        const { scheduleDate, protocolDescription, intervalDescription, prescriptionNumber } = this.props;
        const dateTimeValue = moment(String(scheduleDate)).format('L LTS');
        return (React.createElement("div", { className: 'c-glycemic-details-card__content' },
            React.createElement("div", { className: 'c-glycemic-details-card__content-up' },
                React.createElement("div", { className: 'c-glycemic-details-card__content-up-left' },
                    dateTimeValue && (this.renderDefaultItem(MessageService.translate('label.infusion-viewer.date'), dateTimeValue, '')),
                    protocolDescription != null && (this.renderDefaultItem(MessageService.translate('text.protocol-glycemic'), protocolDescription, '')),
                    intervalDescription && (this.renderDefaultItem(MessageService.translate('text.interval'), intervalDescription, ''))),
                React.createElement("div", { className: 'c-glycemic-details-card__content-down-right' }, prescriptionNumber != null && (this.renderDefaultItem(MessageService.translate('label.infusion-viewer.prescription'), String(prescriptionNumber), '')))),
            React.createElement("div", { className: 'c-glycemic-details-card__content-down' })));
    }
    render() {
        const { glycemicProtocolSequence } = this.props;
        return (React.createElement(Card, { className: 'c-glycemic-details-card', selectionType: SelectionType.SINGLE, uuid: generateUUID(), key: glycemicProtocolSequence, width: 12 },
            React.createElement("div", { className: 'c-glycemic-details-card__wrapper' },
                this.renderDescriptionName(),
                this.renderContent())));
    }
};
GlycemicDetailsCard = __decorate([
    AwesomeComponent({ api: GlycemicDetailsCardAPI, type: ComponentType.DATA_DISPLAY })
], GlycemicDetailsCard);
export default GlycemicDetailsCard;
//# sourceMappingURL=glycemic-details-card.js.map